import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import useStyles from './BirthdaySpinningWheel.styles';
import Button from '../Button/Button';
import { BIRTHDAY_CAMPAIGN } from '../../utils/constants';
import { useRouter } from 'next/router';
export const Winner = ({ couponCode }) => {
    const router = useRouter();
    const { classes } = useStyles();
    const handleNavigateToProduct = () => {
        // Logic to navigate to the product page or handle coupon code
        console.log('Navigating to product with coupon code:', couponCode);
        router.push(BIRTHDAY_CAMPAIGN.WINNER_URL);
    };
    return (_jsxs(Box, { className: classes.leftContent, children: [_jsxs(Box, { className: classes.contentContainer, children: [_jsx(Typography, { variant: "h3", className: classes.title, children: BIRTHDAY_CAMPAIGN.WINNER_TITLE }), _jsx(Typography, { variant: "h5", className: classes.subtitle, children: BIRTHDAY_CAMPAIGN.WINNER_SUBTITLE }), _jsx(Box, { component: 'div', className: classes.description, children: BIRTHDAY_CAMPAIGN.WINNER_DESCRIPTION })] }), _jsx(Button, { title: BIRTHDAY_CAMPAIGN.CLAIM_BOUQUET_CTA_LINK, variant: "primary", thin: true, fullWidth: true, onClick: handleNavigateToProduct })] }));
};
export default Winner;
